import PanelReportView from "./PanelReportView";

export default PanelReportView;
